<script setup lang="ts">
import { useSpyStore } from '@/stores/spyStore.ts'
import SpyDetails from '@/components/Sections/Diplomacy/Spies/SpyDetails.vue'
import { computed } from 'vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useGameStore } from '@/stores/gameStore.ts'

const spyStore = useSpyStore()
const gameStore = useGameStore()

// Convert Map values to an array and sort by level (highest first), then by killed status
const sortedSpies = computed(() =>
  Array.from(spyStore.spies.values()).sort((a, b) => {
    // First, separate alive and dead spies
    if (a.killed !== b.killed) {
      return a.killed - b.killed // alive spies (killed=0) come first
    }
    
    // For alive spies, sort by level (highest first)
    if (a.killed === 0 && b.killed === 0) {
      return b.level - a.level // descending order (highest level first)
    }
    
    // For dead spies, also sort by level (highest first)
    return b.level - a.level
  })
)
</script>

<template>
  <StandardCard title="Spies" class="w-full xl:w-2/3 mx-auto pt-1 px-2 md:px-0">
    Spies allow you to gather intelligence on other empires, sabotage their ships, steal technology, and more. Spies can be assigned to missions, and their success is based on their level and the difficulty of the mission.
    You obtain spies automatically through training. As a spy gains experience, they will level up and become more effective. Spies can also die if they fail their mission and get caught.
    <span v-if="gameStore.combatMode === 'RC'" class="text-red-500">
      Warning: When a spy gets caught, you lose the protection you have against that player.
    </span>
  </StandardCard>
  <div class="grid md:grid-cols-5 grid-cols-2 sm:grid-cols-3 gap-2 w-full xl:w-2/3 mx-auto pt-2 px-2 md:px-0">
    <template v-for="spy in sortedSpies" :key="spy.id">
      <SpyDetails :spy="spy" icon="spy"/>
    </template>
  </div>
</template>

<style scoped lang="scss">
</style>
